export default __webpack_public_path__ + "static/graphic-header-1280-8edadbd947c32929a28793a8dfa908f0.svg";